export default {
  methods: {
    validatePassword (password_) {
      var re1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,100}$/;

      return re1.test(password_);
    },
    validateTfno (tfno_) {
      var re1 = /^\d{9}$/;
      var re2 = /^\d{3}-\d{3}-\d{3}$/;
      var re3 = /^\d{3}\s\d{6}$/;
      var re4 = /^\d{3}\s\d{2}\s\d{2}\s\d{2}$/;
      return (
        re1.test(tfno_) || re2.test(tfno_) || re3.test(tfno_) || re4.test(tfno_)
      );
    },
    validateURL (str) {
      var pattern = new RegExp('^(?:(?:(?:https?):)?\\/\\/)' + // protocol identifier (optional)
      // user:pass BasicAuth (optional)
      '(?:\\S+(?::\\S*)?@)?' +
      '(?:' +
      /*
      // private & local networks
      "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
      "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
      "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
      */
      // IP address dotted notation octets
      // excludes loopback network 0.0.0.0
      // excludes reserved space >= 224.0.0.0
      // excludes network & broadcast addresses
      // (first & last IP address of each class)
      '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
      '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
      '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
      '|' +
      // host & domain names, may end with dot
      // can be replaced by a shortest alternative
      // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
      '(?:' +
        '(?:' +
          '[a-z0-9\\u00a1-\\uffff]' +
          '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
        ')?' +
        '[a-z0-9\\u00a1-\\uffff]\\.' +
      ')+' +
      // TLD identifier name, may end with dot
      '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
      '|localhost' +
    ')' +
    // port number (optional)
    '(?::\\d{2,5})?' +
    // resource path (optional)
    '(?:[/?#]\\S*)?' +
    // prevent ends with "/"
    '(?<!/)$', 'i');
      return !!pattern.test(str);
    },
    validateEmail (email_) {
      // eslint-disable-next-line no-control-regex
      var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },
    myTrim (x) {
      return x.replace(/^\s+|\s+$/gm, '');
    },
    comprobarContraseñas (password, repassword) {
      let Contraseña = this.myTrim(password);
      let RepetirContraseña = this.myTrim(repassword);
      let validate = false;

      if (Contraseña !== '' && RepetirContraseña !== '') {
        if (this.validatePassword(Contraseña) && this.validatePassword(RepetirContraseña)) {
          if (Contraseña === RepetirContraseña) {
            validate = true;
          }
        }
      }

      return validate;
    },
    checkIfFieldEmpty (value) {
      if (value === null || value === '' || value === undefined) {
        return true;
      }

      if (this.myTrim(value) === '') {
        return true;
      }

      return false;
    },
    checkIfEmpty (array) {
      let empty = false;
      array.map((x) => {
        let localVariable = this.myTrim(x);
        if (localVariable === null || localVariable === '' || localVariable === undefined) {
          empty = true;
        }
      });

      return empty;
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }
};
